
import Videos from 'views/public/videos'
import Folletos from 'views/public/folletos'
import Fotografias from 'views/public/fotografias'
import Mapeo from 'views/public/mapeo/mapeo'
import MapsEntomologio from 'views/public/mapeo/entomologico'
import IEC from 'views/public/iec'
import Login from 'views/session/sing-in';
import E500 from 'rutas/e500';
import Icons from 'views/Icons';
import { redirect } from 'react-router-dom'
import ShowMapeoEntomologico from 'views/public/mapeo/ShowMapsEntomologico'
var routes = [
  {
    public: true,
    path: "",
    name: "INICIO",
    icon: "tim-icons icon-heart-2",
    component: <IEC />,
    layout: '/',
  },

  {
    public: true,
    path: "georef",
    name: "GEOREF",
    icon: "tim-icons icon-pin",
    component: <Mapeo />,
    layout: '/',
  },

  {
    public: true,
    path: "maps-entomologico",
    name: "ENTOMOLOGICO",
    icon: "tim-icons icon-pin",
    component: <MapsEntomologio />,
    layout: '/',
    sidevar :false,
  },

  {
    public: true,
    // path: "map-entomologico/:entidad/:level",
    path: "map-entomologico-1",
    name: "ENTOMOLOGICO q",
    icon: "tim-icons icon-pin",
    component: <ShowMapeoEntomologico />,
    layout: '/',
    // sidevar:false
  },

  {
    public: true,
    path: "fotografias",
    name: "FOTOGRAFIAS",
    icon: "tim-icons icon-camera-18",
    component: <Fotografias />,
    layout: '/',
  },

  {
    public: true,
    path: "/videos",
    path: "videos",
    name: "VIDEOS",
    icon: "tim-icons icon-video-66",
    component: <Videos />,
    layout: '/',
  },

  {
    public: true,
    path: "/folletos",
    path: "folletos",
    name: "FOLLETOS",
    icon: "tim-icons icon-book-bookmark",
    component: <Folletos />,
    layout: '/',
  },

  {
    public: true,
    path: "/login",
    path: "login",
    name: "LOGIN",
    icon: "tim-icons icon-lock-circle",
    component: <Login />,
    layout: '/',
  },
  // {
  //   public: true,
  //   path: "/icons",
  //   path: "icons",
  //   name: "ICONS",
  //   icon: "tim-icons icon-video-66",
  //   component: <Icons />,
  //   layout: '/',
  // },

];
export default routes;
